import {Animation} from "./Animation";
import {Mobile} from "./Mobile";
import {ShareUrl} from "./ShareUrl";
import {GA} from "./GA";

export class SignToDonate {
    static isSubmitting = false;

    static init() {
        SignToDonate.handleInit();
        SignToDonate.handlePetitionSubmit(); // Vrátíme volání naší metody
        SignToDonate.handleStepNavigationBtns();
        SignToDonate.handleDonationForm();
        SignToDonate.handleSharing();
        SignToDonate.handleStepNavigation();
        SignToDonate.handleFinalSteps();
    }
    
    static handlePetitionSubmit() {
        var $ = jQuery;
        
        $(document).on('submit', '.sign-to-donate[data-step="petition"] .petition-form', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (SignToDonate.isSubmitting) {
                return false; 
            }
            
            var form = this;
            var $form = $(form);

            // Manuálně spustíme validaci a zkontrolujeme výsledek
            if (!$form.valid()) {
                // Pokud formulář není validní, validátor sám zobrazí chyby. My jen skončíme.
                return false;
            }
            
            // Pokud je formulář validní, zamkneme a odešleme
            SignToDonate.isSubmitting = true;
            SignToDonate.submitPetitionForm(form);
            
            return false;
        });
    }
   
    static submitPetitionForm(formElement) {
        var $ = jQuery;
        var $form = $(formElement);
        var $signToDonate = $form.closest('.js-sign-to-donate-container');
        var data = new FormData(formElement);

        data.set('action', 'sign_to_donate_petition_form');
        
        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                if (response.success && response.data.hashed_user_id) {
                    console.log("-> GTM Event ze SignToDonate.js (AJAX success)");
                    
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': 'petitionSignup',
                        'gp_user_id': response.data.hashed_user_id
                    });
                }

                // Uložíme věk a aktualizujeme UI (např. navigační lištu)
                sessionStorage.setItem('sign-to-donate-is-under-18', response.data.is_under_18 ? '1' : '0');
                SignToDonate.updateUserInterface();

                // Připravíme data pro další krok
                SignToDonate.animateSignature($signToDonate);
                SignToDonate.donationFormUTMParams($signToDonate);
                SignToDonate.fillDonationFormData($signToDonate);

                // Označíme kroky jako splněné
                SignToDonate.setCompletedStep($signToDonate, 'petition');
                SignToDonate.setCompletedStep($signToDonate, 'signature');

                // Zavoláme GTM pro nový krok
                GA.utmSignToDonatePetitionThankYouInit();

                // Až teď, když je vše připraveno, spustíme JEDINÝ přechod na další krok
                SignToDonate.initStep('signature');
            },
            error: function(err) {
                console.error("AJAX chyba při odesílání petice:", err);
            },
            // === KROK 4: ODEMKNEME PO DOKONČENÍ AJAXU ===
            complete: function() {
                SignToDonate.isSubmitting = false;
            }
        });
    }

    /**
     * TATO FUNKCE OBSAHUJE VŠECHNU VIZUÁLNÍ LOGIKU.
     */
    static updateUserInterface() {
        var $ = jQuery; // Zajistíme si přístup k jQuery
        const isUnder18 = sessionStorage.getItem('sign-to-donate-is-under-18') === '1';
        const sharingSettings = window.signToDonateSharingSettings || {};
        const enableUnder = String(sharingSettings.enable_under_18) === 'true';
        const enableOver = String(sharingSettings.enable_over_18) === 'true';

        // --- 1. Logika pro finální krok v NAVIGACI (Dar vs. Zapojení) ---
        if (isUnder18) {
            $('.step-donation').hide();
            $('.step-engagement').show().css('display', 'list-item'); // .show() dává 'block', musíme upřesnit
        } else {
            $('.step-engagement').hide();
            $('.step-donation').show().css('display', 'list-item');
        }

        // --- 2. Logika pro ZOBRAZENÍ kroku Sdílení v NAVIGACI ---
        let shouldSharingBeVisibleForNav = isUnder18 ? enableUnder : enableOver;
        const $sharingNavItem = $('.sign-to-donate__step-nav-item[data-step="sharing"]');

        if ($sharingNavItem.length) {
            if (shouldSharingBeVisibleForNav) {
                $sharingNavItem.show().css('display', 'list-item');
            } else {
                $sharingNavItem.hide();
            }
        }

        // --- 3. (OPRAVENO) Logika pro TLAČÍTKA v kroku "Poděkování" ---
        const $signatureStep = $('.sign-to-donate[data-step="signature"]');
        if ($signatureStep.length) {
            const $enabledButtons = $signatureStep.find('.pagination-sharing-enabled');
            const $disabledButtons = $signatureStep.find('.pagination-sharing-disabled');

            // Znovu určíme, zda má být sdílení vidět, tentokrát pro tlačítka
            let shouldSharingBeVisibleForButtons = isUnder18 ? enableUnder : enableOver;

            if (shouldSharingBeVisibleForButtons) {
                $enabledButtons.show();
                $disabledButtons.hide();
            } else {
                $enabledButtons.hide();
                $disabledButtons.show();
            }
        }

        SignToDonate.rerenderStepNav();
    }

    static handleInit() {
        var $ = jQuery;
        
        // Původní podmínka zajišťovala, že se kód provede jen jednou za session.
        // My teď chceme, aby se mazání provedlo VŽDY.
        if (!sessionStorage.getItem('sign-to-donate-session-started')) {
            sessionStorage.setItem('sign-to-donate-session-started', '1');
        }
        
        sessionStorage.setItem('sign-to-donate-session-started', '1');
        sessionStorage.removeItem('sign-to-donate-step');
        sessionStorage.removeItem('sign-to-donate-completed-steps');
        sessionStorage.removeItem('sign-to-donate-ignored-steps');
        sessionStorage.removeItem('signature-auto-advanced');

        $(document.body).addClass('sign-to-donate-animation');
        if ($('.js-sign-to-donate-container').length > 0) {
            GA.utmSignToDonateInit();
        }
        SignToDonate.updateUserInterface();
        SignToDonate.initStep(SignToDonate.loadCurrentStep());
    }

    static handleSharing() {
        var $ = jQuery;

        $(document.body).on('click', '.js-donate-sharing', function (e) {
            e.preventDefault();
            var $target = $(e.target);
            var eventAction = $target.attr('data-type');
            var url = window.location.href;
            
            // ... (sdílecí logika zůstává stejná)
            switch (eventAction) {
                case 'facebook': ShareUrl.facebook(url, Mobile.isPhone()); break;
                case 'twitter': ShareUrl.twitter(url, Mobile.isPhone()); break;
                case 'whatsapp': ShareUrl.whatsapp(url, Mobile.isPhone()); break;
                case 'email': ShareUrl.email(url, Mobile.isPhone()); break;
            }

            // ZMĚNA (dle specifikace): Označí krok jako splněný jen po kliku na sdílecí tlačítko
            SignToDonate.saveCompletedStep('sharing');
            
            // UTM
            GA.utmSharing(eventAction);
        })
    }
    
    // ZMĚNA (dle specifikace): Nová funkce pro označení finálních kroků
    static handleFinalSteps() {
        var $ = jQuery;
        
        $(document.body).on('click', '.js-engagement-cta', function() {
            SignToDonate.saveCompletedStep('engagement');
        });

        $(document.body).on('submit', '#support-form', function() {
            SignToDonate.saveCompletedStep('donation');
        });
    }

    static handleClose() {
        $(document.body).on('click', '.js-sign-to-donate-close', function (e) {
            GA.utmShareClose();
        })
    }

    static handleDonationForm() {
        var $ = jQuery;
        $(document.body).on('submit', '.js-sign-to-donate-donate .support-form', function (e) {
            var $target = $(e.target);
            var $signToDonate = $target.closest('.js-sign-to-donate');
            var frequency = $target.find('input[name="frequency"]').val();
            var value = $target.find('input[name="amount"]');
            var eventAction = frequency == 'monthly' ? 'Regular' : 'Single';

            // GA
            GA.utmDonate(eventAction, value);
            SignToDonate.setCompletedStep('donation');
            SignToDonate.rerenderStepNav();
        })

        $(document.body).on('submit', '#support-form', function() {
            SignToDonate.saveCompletedStep('donation');
        })
    }
    
    /**
     * @param {jQuery} $signToDonate
     */
    static animateSignature($signToDonate) {
        var $ = jQuery;
        //
        var $signature = $signToDonate.find('.js-sign-to-donate-signature');
        var $progressBar = $signature.find('.progress-bar');
        var $progressBarCount = $progressBar.find('.js-progress-count');
        var $progressLine = $progressBar.find('.js-progress-line');
        var lineTo = $progressLine.attr('data-line');
        var countTo = $progressBarCount.attr('data-count');
        countTo = countTo ? countTo.replace(/\s/g, '') : countTo;
        countTo = parseFloat(countTo) + 1;
        lineTo = lineTo ? lineTo.replace(/\s/g, '') : lineTo;
        lineTo = parseFloat(lineTo);

        // --- Animate progress line
        $progressBarCount.attr('data-count', countTo);
        $progressLine.attr('data-line', lineTo);

        // --- Animate progress bar
        Animation.animatePetitionProgressBar($progressBar);
    }

    // ZMĚNA (dle specifikace): Umožňuje volný pohyb mezi kroky
    static handleStepNavigation() {
        var $ = jQuery;
        $(document.body).on('click', '.sign-to-donate__step-nav-item', function (e) {
            var $this = $(this);
            var destinationStep = $this.attr('data-step');

            if ($this.hasClass('current')) {
                return; 
            }
            
            // === PŘIDANÁ LOGIKA PRO DETEKCI PŘESKOČENÍ ===
            const currentStep = SignToDonate.loadCurrentStep();
            const sharingIsEnabled = $('.sign-to-donate__step-nav-item[data-step="sharing"]').is(':visible');

            // Pokud jsme na kroku "Podpis" a klikáme na finální krok (dar/zapojení)
            // a krok sdílení je aktivní, označíme sdílení jako přeskočené.
            if (currentStep === 'signature' && ['donation', 'engagement'].includes(destinationStep) && sharingIsEnabled) {
                console.log("Krok 'sharing' byl přeskočen pomocí navigace.");
                SignToDonate.saveIgnoredStep('sharing');
            }
            
            SignToDonate.initStep(destinationStep);
        });
    }

    static handleStepNavigationBtns() {
        var $ = jQuery;
        $(document.body).on('click', '.js-sign-to-donate-next', function (e) {
            var $btn = $(e.target);
            var nextStep = $btn.attr('data-next-step');
            var successStep = $btn.attr('data-success-step');
            var ignoredStep = $btn.attr('data-ignored-step');

            const isUnder18 = sessionStorage.getItem('sign-to-donate-is-under-18') === '1';
            if (nextStep === 'donation' && isUnder18) {
                nextStep = 'engagement';
            }

            // Označíme aktuální/přeskočený krok
            if (successStep) {
                SignToDonate.saveCompletedStep(successStep);
            }
            if (ignoredStep) {
                SignToDonate.saveIgnoredStep(ignoredStep);
            }

            // Použijeme centrální funkci pro přechod, která už v sobě má animaci i scroll
            SignToDonate.initStep(nextStep);
        });
    }

    /**
     * @param {jQuery} $form Petition form
     */
    static donationFormUTMParams($signToDonate) {
        var $ = jQuery;
        var $form = $signToDonate.find('.petition-form');
        var $donationForm = $signToDonate.find('#support-form');
        //
        const utm_source = $form.find('input[name="utm_source"]').val();
        const utm_medium = $form.find('input[name="utm_medium"]').val();
        const utm_campaign = $form.find('input[name="utm_campaign"]').val();
        const utm_content = $form.find('input[name="utm_content"]').val();
        const utm_term = $form.find('input[name="utm_term"]').val();
        //
        // -- Modilfy url
        try {
            $donationForm.remove('.js-custom-utm-param');
            var $input = $('<input/>')
                .addClass('js-custom-utm-param')
                .attr('type', 'hidden');

            if (utm_source) {
                $input = $input.clone();
                $input.attr('name', 'custom[utm_source]');
                $input.attr('value', utm_source);
                //
                $donationForm.append($input);
            }
            if (utm_medium) {
                $input = $input.clone();
                $input.attr('name', 'custom[utm_medium]');
                $input.attr('value', utm_medium);
                //
                $donationForm.append($input);
            }
            if (utm_campaign) {
                $input = $input.clone();
                $input.attr('name', 'custom[utm_campaign]');
                $input.attr('value', utm_campaign);
                //
                $donationForm.append($input);
            }
            if (utm_content) {
                $input = $input.clone();
                $input.attr('name', 'custom[utm_content]');
                $input.attr('value', utm_content);
                //
                $donationForm.append($input);
            }
            if (utm_term) {
                $input = $input.clone();
                $input.attr('name', 'custom[utm_term]');
                $input.attr('value', utm_term);
                //
                $donationForm.append($input);
            }
            //
        } catch (e) {
            console.log("Error construct url:");
            console.log(e);
        }
    }

    // ----------------------------------------- Fill data ----------------------------------------------- \\

    /**
     * @param {jQuery} $form Petition form
     */
    static fillDonationFormData($signToDonate) {
        var $form = $signToDonate.find('.petition-form');
        var $donationForm = $signToDonate.find('#support-form');
        //
        var firstName = $form.find('input[name="first_name"]').val();
        var lastName = $form.find('input[name="last_name"]').val();
        var email = $form.find('input[name="email"]').val();
        var phoneNumber = $form.find('input[name="phone_number"]').val();
        //
        $donationForm.find('input[name="firstName"]').attr('value', firstName);
        $donationForm.find('input[name="lastName"]').attr('value', lastName);
        $donationForm.find('input[name="email"]').attr('value', email);
        $donationForm.find('input[name="phone"]').attr('value', phoneNumber);
        $donationForm.find('input[name="phone_number"]').attr('value', phoneNumber);
        //
        var countryCode = $form.find('.iti__selected-flag')
            .attr('aria-activedescendant')
            .replace('iti-0__item-', '')
            .replace('iti-1__item-', '');
        countryCode = countryCode.replace('-preferred', '');
        countryCode = countryCode.toUpperCase();
        try {
            intlTelInput($donationForm.find('input[name="phone_number"]')[0]).setCountry(countryCode);
        } catch (e) {
            console.log(e);
        }
        // fade
        $donationForm.find('input[name="firstName"]').closest('.moved-input-container')
            .addClass('is-floating');
        $donationForm.find('input[name="lastName"]').closest('.moved-input-container')
            .addClass('is-floating');
        $donationForm.find('input[name="email"]').closest('.moved-input-container')
            .addClass('is-floating');
        $donationForm.find('input[name="phone"]').closest('.moved-input-container')
            .addClass('is-floating');
        $donationForm.find('input[name="phone_number"]').closest('.moved-input-container')
            .addClass('is-floating');
    }


    // ------------------------------------------ Set step ----------------------------------------------- \\

    /**
     * @param {jQuery} $signToDonate
     * @param {string} step
     */
    static setCompletedStep($signToDonate, step) {
        if (!step) return; // Pojistka proti prázdné hodnotě
        SignToDonate.saveCompletedStep(step);
    }
    
    /**
     * @param {jQuery} $signToDonate
     * @param {string} step
     */
    static setIgnoredStep($signToDonate, step) {
        if (!step) return;
        SignToDonate.saveIgnoredStep(step);
    }
    
    static setCurrentStep($signToDonate, currentStep) {
        var $ = jQuery;
        var $stepNav = $signToDonate.find('.js-sign-to-donate-step-nav');
        var $currentStepEl = $stepNav.find('[data-step=' + currentStep + ']');

        SignToDonate.saveCurrentStep(currentStep);

        switch (currentStep) {
            case "sharing": GA.utmSignToDonateSharingInit(); break;
            case "donation": GA.utmSignToDonateDonationInit(); break;
        }
    }

    static showStepAnimation() {
        var $ = jQuery;

        $(document.body).addClass('sign-to-donate-animation--show');
        $(document.body).addClass('sign-to-donate-animation--z-index');
    }

    static hideStepAnimation() {
        var $ = jQuery;

        $(document.body).removeClass('sign-to-donate-animation--show');
        //
        window.setTimeout(function () {
            $(document.body).removeClass('sign-to-donate-animation--z-index');
        }, SignToDonate.animationDuration());
    }

    // ------------------------------------------ Components ----------------------------------------------- \\

    static animationDuration() {
        return 600; // 0.6s
    }

    static showStepComponents(step) {
        var $ = jQuery;
        // Hide components
        $("*[data-sign-to-donate-step]").removeClass("show");
        // Show components
        $("*[data-sign-to-donate-step='" + step + "']").addClass('show');
    }

    // --------------------------------------- Steps helper functions --------------------------------------------- \\

    // --- Completed step
    static saveCompletedStep(step) {
        let completed = this.loadCompletedSteps();
        if (step && !completed.includes(step)) {
            completed.push(step);
        }
        sessionStorage.setItem("sign-to-donate-completed-steps", JSON.stringify(completed));
        SignToDonate.rerenderStepNav();
    }

    static loadCompletedSteps() {
        try { 
            return JSON.parse(sessionStorage.getItem("sign-to-donate-completed-steps")) || []; 
        } catch (e) { return []; }
    }

    static saveIgnoredStep(step) {
        let ignored = this.loadIgnoredSteps();
        if (step && !ignored.includes(step)) {
            ignored.push(step);
        }
        sessionStorage.setItem("sign-to-donate-ignored-steps", JSON.stringify(ignored));
    }
    
    static removeIgnoredStep(step) {
        let ignored = this.loadIgnoredSteps();
        const newIgnored = ignored.filter(item => item !== step);
        sessionStorage.setItem("sign-to-donate-ignored-steps", JSON.stringify(newIgnored));
    }

    static loadIgnoredSteps() {
        try { 
            return JSON.parse(sessionStorage.getItem("sign-to-donate-ignored-steps")) || []; 
        } catch (e) { return []; }
    }

    // --- Current step
    static saveCurrentStep(step) {
        sessionStorage.setItem("sign-to-donate-step", step);
        SignToDonate.showStep(step);
        SignToDonate.rerenderStepNav();
        SignToDonate.showStepComponents(step);

        if(['signature', 'sharing'].includes(step)) {
            SignToDonate.hideHeader();
            SignToDonate.hideFooter();
        } else {
            SignToDonate.showFooter();
            SignToDonate.showHeader();
        }
    }

    static loadCurrentStep() {
        let step = sessionStorage.getItem("sign-to-donate-step");
        if (!step) {
            step = "petition";
        }
        return step;
    }

    static initStep(step) {
        var $ = jQuery;
        var $signToDonate = $('.js-sign-to-donate-container');
        
        if (step !== 'petition') {
            SignToDonate.showStepAnimation();
        }

        window.setTimeout(function () {
            SignToDonate.setCurrentStep($signToDonate, step);
            SignToDonate.showStepComponents(step);
            SignToDonate.showStep(step);
            SignToDonate.hideStepAnimation();
            SignToDonate.rerenderStepNav();
            
            // === PŘIDANÁ LOGIKA PRO SCROLLOVÁNÍ ===
            var $container = $('.js-sign-to-donate-container');
            if ($container.length) {
                $('html, body').animate({
                    scrollTop: $container.offset().top - 30 // -30px pro malý buffer od horního okraje
                }, 400); // 400ms animace
            }
        }, (step !== 'petition' ? SignToDonate.animationDuration() : 0));

        return step;
    }

    // ------------------------------------- Hide & show components by step ---------------------- \\

    static showStepNav() {
        var $ = jQuery;
        var $stepNav = $('.js-sign-to-donate-step-nav');
        $stepNav.css({"opacity": 1, visibility: "visible"});
    }

    // ZMĚNA (dle specifikace): Správná hierarchie barev (zelená má přednost)
    static rerenderStepNav() {
        var $ = jQuery;
        var $stepNav = $('.js-sign-to-donate-step-nav');

        const currentStep = SignToDonate.loadCurrentStep();
        const completedSteps = SignToDonate.loadCompletedSteps();
        const ignoredSteps = SignToDonate.loadIgnoredSteps();
        const allNavItems = $stepNav.find('.sign-to-donate__step-nav-item');

        allNavItems.each(function() {
            const $item = $(this);
            const itemStep = $item.data('step');

            $item.removeClass('current completed ignored');

            // HIERARCHIE: Zelená (splněno) má nejvyšší prioritu
            if (completedSteps.includes(itemStep)) {
                $item.addClass('completed');
            } 
            // Až potom řešíme oranžovou (aktuální) a červenou (přeskočeno)
            else if (currentStep === itemStep) {
                $item.addClass('current');
            } 
            else if (ignoredSteps.includes(itemStep)) {
                $item.addClass('ignored');
            }
        });
    }

    static showStep(step) {
        var $ = jQuery;
        $('.sign-to-donate').removeClass('show');
        $('.sign-to-donate[data-step="' + step + '"]').addClass('show');

        if (step !== "petition") {
            SignToDonate.showStepNav();
        }

        if(step === 'signature') {
            const isUnder18 = sessionStorage.getItem('sign-to-donate-is-under-18') === '1';
            const sharingSettings = window.signToDonateSharingSettings || {};
            const enableUnder = String(sharingSettings.enable_under_18) === 'true';
            const enableOver = String(sharingSettings.enable_over_18) === 'true';
            const sharingIsEnabledForThisUser = isUnder18 ? enableUnder : enableOver;

            if (!sharingIsEnabledForThisUser && !sessionStorage.getItem('signature-auto-advanced')) {

                SignToDonate.animateBottomLoader();

                window.setTimeout(function() {
                    if(SignToDonate.loadCurrentStep() === 'signature') {

                        sessionStorage.setItem('signature-auto-advanced', '1');

                        SignToDonate.showStepAnimation();
                        window.setTimeout(function () {
                            SignToDonate.setCompletedStep($('.js-sign-to-donate-container'), 'signature');

                            // --- FINÁLNÍ OPRAVA ZDE ---
                            // Dynamicky určíme správný finální krok podle věku
                            const finalStep = isUnder18 ? 'engagement' : 'donation';
                            SignToDonate.setCurrentStep($('.js-sign-to-donate-container'), finalStep);

                            SignToDonate.hideStepAnimation();
                        }, SignToDonate.animationDuration());
                    }
                }, 10000);
            }
        }
    }

    // --- Header footer
    static hideHeader()
    {
        var $ = jQuery;
        //
        $('header').addClass('hide');
    }

    static hideFooter()
    {
        var $ = jQuery;
        //
        $('footer').addClass('hide');
    }

    static showHeader()
    {
        var $ = jQuery;
        //
        $('header').removeClass('hide');
    }

    static showFooter()
    {
        var $ = jQuery;
        //
        $('footer').removeClass('hide');
    }

    static animateBottomLoader()
    {
        var $ = jQuery;
        $('.sign-to-donate--bottom-loader')
            .show()
            .animate({width: 0}, 10000 );
    }
}